module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#close",
      toString: function () {
        return this.url;
      }
    }